import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_BEGIN,
  ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_SUCCESS,
  ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_FAILURE,
  ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function installMultiTenantPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/on-boarding/install/multi-tenant-plugin`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(url, args, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_SUCCESS,
              data: res,
            });
            toast.success('Multi Tenant Plugin Installed Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            resolve('Failed');
          }
        },
        (err) => {
          dispatch({
            type: ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissInstallMultiTenantPluginError() {
  return {
    type: ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_BEGIN:
      return {
        ...state,
        installMultiTenantPluginPending: true,
        installMultiTenantPluginError: null,
      };

    case ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_SUCCESS:
      return {
        ...state,
        installMultiTenantPluginPending: false,
        installMultiTenantPluginError: null,
      };

    case ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_FAILURE:
      return {
        ...state,
        installMultiTenantPluginPending: false,
        installMultiTenantPluginError: action.data.error,
      };

    case ON_BOARDING_INSTALL_MULTI_TENANT_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        installMultiTenantPluginError: null,
      };

    default:
      return state;
  }
}
